import { makeStyles } from '@mui/styles'
import {
  CHARCOAL,
  GAINSBORO_BORDER,
  GRAYISH_BLUE,
  GUNMETAL,
  LIGHT_GRAY,
  MEDIUM_GRAY,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  SHAMROCK,
  VIVID_BLUE,
  WHITE,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

import { POPPINS } from '../../constants/styles/fonts'

const useStyles = makeStyles(() => ({
  statusSelect: {
    width: '100%',
    padding: 5,

    '& > div': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  detailsTypeWithHeadTooltip: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  headTooltip: {
    fontFamily: URBANIST,
    fontSize: 12,
    cursor: 'pointer',
  },
  helpIcon: {
    width: 14,
    height: 14,
  },
  optionPrimary: {
    fontFamily: URBANIST,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '160%',
    color: MIDNIGHT_EXPRESS,
    cursor: 'pointer',
  },
  detailsRow: {
    display: 'flex',
    alignItems: 'center',
    '&:not(:first-child)': {
      marginTop: 3,
    },
  },
  inputHead: {
    flexShrink: 0,
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0.2,
    width: '30%',
    marginRight: 10,
    color: CHARCOAL,
  },
  inputText: {
    fontFamily: URBANIST,
    fontSize: 14,
    lineHeight: '150%',
  },
  input: {
    '& > div': {
      borderColor: 'transparent',
      '& > input': {
        fontFamily: URBANIST,
        color: MIDNIGHT_EXPRESS,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '160%',
      },
    },
  },
  datePicker: {
    '& > div': {
      border: '2px solid transparent',
    },
  },
  copyIcon: {
    color: GRAYISH_BLUE,
  },
  table: {
    borderCollapse: 'collapse',
  },
  tableHead: {
    width: '100%',
    height: 'auto',
    border: 'none',
  },
  headerRow: {
    backgroundColor: 'RGBA(189, 189, 189, 0.2)',
    borderBottom: `1px solid RGBA(189, 189, 189, 0.2)`,

    '&:hover': {
      backgroundColor: 'RGBA(189, 189, 189, 0.2)',
      borderBottom: `1px solid RGBA(189, 189, 189, 0.2)`,
    },
  },
  headerCell: {
    color: 'RGBA(2, 2, 2, 0.2)',
    padding: 5,
    fontFamily: URBANIST,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '130%',
  },
  tableRow: {
    border: 'none',
    cursor: 'auto',
  },
  bodyCell: {
    padding: 5,
    borderBottom: `1px solid ${GAINSBORO_BORDER}`,
    color: GUNMETAL,
    fontFamily: URBANIST,
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '130%',
  },
  upperCaseText: {
    textTransform: 'uppercase',
  },
  noWrapText: {
    whiteSpace: 'nowrap',
  },
  inputRoot: {
    width: '100%',
  },
  selectWrapper: {
    width: '100%',
    position: 'relative',
    borderRadius: 4,
  },
  packageIdCell: {
    maxWidth: 120,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: VIVID_BLUE,
  },
  openLinkCell: {
    display: 'inline-flex',
    alignItems: 'center',
    opacity: 0.4,
    cursor: 'pointer',

    '&:hover': {
      opacity: 1,
    },
  },
  errorBlock: {
    margin: 20,
  },
  wrongPickedUpItemCheckbox: {
    padding: 0,
  },
  buttonsContainer: {
    position: 'fixed',
    width: '30%',
    bottom: 0,
    background: WHITE,
    borderTop: `1px solid ${GAINSBORO_BORDER}`,
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 -10px',
    padding: 10,
  },
  button: {
    padding: '0 10px',
    fontFamily: URBANIST,
    letterSpacing: 0.2,
    fontSize: 14,
    lineHeight: '140%',
    fontWeight: 700,
    height: 40,
    border: 'none',
    borderRadius: 4,

    '&:hover': {
      opacity: 0.8,
    },
  },
  cancelButton: {
    backgroundColor: MEDIUM_GRAY,
    color: WHITE,

    '&:hover': {
      backgroundColor: MEDIUM_GRAY,
      border: 'none',
    },
  },
  saveButton: {
    backgroundColor: NEON_BLUE_LIGHT,
    color: WHITE,

    '&:hover': {
      backgroundColor: NEON_BLUE_LIGHT,
      border: 'none',
    },
  },
  link: {
    fontFamily: URBANIST,
    letterSpacing: 0.2,
    fontSize: 14,
    textDecoration: 'none',
  },
  scheduleOnfleet: {
    color: NEON_BLUE_LIGHT,
    fontFamily: URBANIST,
    letterSpacing: 0.2,
    fontSize: 14,
    marginTop: 10,
    cursor: 'pointer',
  },
  scheduleOnfleetLoading: {
    color: '#A7B4C8',
  },
  mediaContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -3px',
  },
  mediaItem: {
    width: 'max-content',
    height: 'max-content',
    margin: '3px',
  },
  mediaImage: {
    width: 40,
    height: 40,
    objectFit: 'cover',
    cursor: 'pointer',
  },
  spinner: {
    position: 'relative',
  },
  id: {
    maxWidth: '70%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    fontFamily: URBANIST,
    fontSize: 14,
    lineHeight: '120%',
    letterSpacing: 0.2,
  },
  idActions: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',

    '& > svg': {
      cursor: 'pointer',
      opacity: 0.4,

      '&:hover': {
        opacity: 1,
      },
    },
  },
  idContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 5,
  },
  idsContainer: {
    marginBottom: 10,
  },
  rescheduleWrapper: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: LIGHT_GRAY,
    padding: 5,
    borderRadius: 4,
  },
  rescheduledText: {
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0.2,
    color: CHARCOAL,
    marginRight: 15,
    marginLeft: -5,
  },
  scrollContainer: {
    overflowX: 'auto',
    scrollbarWidth: 'thin',

    '&::-webkit-scrollbar': {
      height: 3,
      width: 6,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,0.3)',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
  },
  rescheduleButton: {
    backgroundColor: SHAMROCK,
    color: WHITE,

    '&:hover': {
      backgroundColor: SHAMROCK,
      border: 'none',
    },
  },
  rescheduleDisabledButton: {
    backgroundColor: `${SHAMROCK} !important`,
    opacity: 0.5,

    '&:hover': {
      backgroundColor: `${SHAMROCK} !important`,
      opacity: 0.5,
    },
  },
  rescheduleModal: {
    padding: '55px 25px 15px',
    overflow: 'hidden',
    overflowY: 'auto',
  },
  rescheduleModalHeader: {
    fontFamily: POPPINS,
    fontWeight: 600,
    fontSize: 30,
    lineHeight: '130%',
    color: MIDNIGHT_EXPRESS,
    textAlign: 'center',
    paddingTop: 10,
  },
  rescheduleModalButtonsGroup: {
    marginTop: 10,
    display: 'flex',
    gap: 20,
  },
  rescheduleModalButton: {
    width: '100%',
  },
}))

export default useStyles
